import React from 'react';
import { fromPairs, map, get, isEqual } from 'lodash';
import classnames from 'classnames';

import { Form } from 'modules/form';
import { getLabel } from 'utils/getLabel';
import { Icon } from 'modules/icon-bank';
import { button as Button } from 'modules/button';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { callMarkResolveForm as CallMarkResolveForm } from 'ui/views/widgets/callMarkResolveForm';
 *
 * // render
 * <CallMarkResolveForm propName='propValue'/>
 */
export const callMarkResolveForm = ( props ) => {

    const { actions = [] } = props;

    return (
        <div className='ui-call-mark-resolve-form'>

             <div className='ui-call-mark-resolve-form__header'>

                {/* title for the modal */}
                <div className='ui-call-mark-resolve-form__header__title'>
                    { getLabel( get( props, 'title', {} ) ) }
                </div>

                {/* close button */}
                <div className='ui-error-overlay__head__close' onClick={ () => props.closeOverlay() }>
                    <Icon name='close' width='14' height='14' fill='#ffffff' />
                </div>

            </div>

            <div className='ui-call-mark-resolve-form__body'>

                <Form
                    fields={ fromPairs( map( props.fields, ( field ) => [ field.name, field ] ) ) } // convert to object as specified by `Form` prop
                    values={ props.values } // default values
                    isValid={ false }
                    key={ props.formId }
                    onSubmit={ ( { values, isValid } ) => {

                        props.onSubmitClick( { values, isValid } );

                    } }
                    onChangeCallBack= { ( { values } ) => {

                        props.onFormUpdate( { values } );
                    } }
                >
                    { ( { fields, values, isValid, errors, onChange, onSumbit } = {} ) => {

                        return (
                            <form
                                onSubmit={ onSumbit }
                                className='ui-call-mark-resolve-form__body__form'
                            >
                                { /* fields */ }
                                { map( fields, ( field ) => {
                                    
                                    const className = classnames(
                                        'ui-call-mark-resolve-form__body__form__field',
                                        `ui-call-mark-resolve-form__body__form__field--${ field.name }`
                                    );

                                    return (
                                        <field.view
                                            className={ className }
                                            key={ field.name }
                                            name={ field.name }
                                            required={ field.required }
                                            config={ field.config }
                                            placeholder={ field.placeholder }
                                            label={ field.title }
                                            onChange={ onChange }
                                            value={ values[ field.name ] }
                                            error={ errors[ field.name ] }
                                            options={ get( props, `options.${ field.options }` ) }
                                            mask={ field.mask }
                                        />
                                    );
                                } ) }

                                {/* button actions */}
                                <div className='ui-call-mark-resolve-form__body__form__actions'>
                                    { map( actions, action => {
                                        return (
                                            <Button
                                                { ...action }
                                                key={ action.name }
                                                id= { action.name }

                                                type= { 'cancel' !== action.name ? 'submit' : 'button' }
                                                disabled={ 'cancel' !== action.name ? !isValid : false }
                                                outline={ 'cancel' === action.name ? true: false }
                                                size='medium'
                                                className='ui-call-mark-resolve-form__body__form__actions__action'
                                                onClick = { isEqual( 'cancel', action.name ) ? () => {
                                                    props.closeOverlay();
                                                } : null }
                                            />
                                        );
                                    } ) }
                                </div>

                            </form>
                        );
                    } }
                </Form>
            </div>

            
        </div>
    );
};

// set display name
callMarkResolveForm.displayName = 'callMarkResolveForm';

// set default props
callMarkResolveForm.defaultProps = {};

// prop types
callMarkResolveForm.propTypes = {};
